import Swal from 'sweetalert2';
import { domain } from '../../../../Urls/Services/Api_urls';
import { Trash } from 'iconoir-react';

export const DeleteOrder = (props) => {
    const groups = window.sessionStorage.getItem("groups");
    const token = window.sessionStorage.getItem("token");
    const last_name = window.sessionStorage.getItem("last_name").toUpperCase();
    const tableMeta = props.tableMeta;
    const Caus = props.Causable;
    const isCustomer = groups === "Usuario" || groups === "Usuario_Universidades";
    const actionLabel = isCustomer ? "Cancelar solicitud" : "Rechazar solicitud";
    const reasonNoun = isCustomer ? "cancelación" : "rechazo";
    const reasonOf = isCustomer ? "de la cancelación" : "del rechazo";
    const reasonThe = isCustomer ? "la cancelación" : "el rechazo";

    const rechazar = () => {
        Swal.fire({
            title: actionLabel,
            html: `
            <form class="text-start">
                <div class="px-2 py-1">
                    <div class="mb-3">
                        <label for="swal-observations" class="form-label fw-semibold small text-secondary d-block text-start">
                            Observaciones <span class="text-danger">*</span>
                        </label>
                        <textarea id="swal-observations" class="form-control" rows="5" placeholder="Describe brevemente el motivo ${reasonOf}"></textarea>
                    </div>
                    <div class="mb-1">
                        <label for="potential_client" class="form-label fw-semibold small text-secondary d-block text-start">
                            Causal de ${reasonNoun} <span class="text-danger">*</span>
                        </label>
                        <select class="form-select" id="potential_client">
                            <option value="" disabled selected>Selecciona un causal</option>
                            ${Caus.map(opcion => `<option value="${opcion.id}" data-name="${opcion.name_cause}">${opcion.name_cause}</option>`).join('')}
                        </select>
                        <input type="hidden" id="causal_id" value="" />
                    </div>
                </div>
            </form>
            `,
            focusConfirm: false,
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: actionLabel,
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#30125d",
            cancelButtonColor: "#6c757d",
            reverseButtons: true,
            didOpen: () => {
                const selectElement = document.getElementById('potential_client');
                const textareaElement = document.getElementById('swal-observations');
                const causalIdElement = document.getElementById('causal_id');
                let lastAutoText = '';

                selectElement.addEventListener('change', (e) => {
                    const selectedOption = e.target.selectedOptions[0];
                    const id = e.target.value;
                    const name = selectedOption ? selectedOption.dataset.name : '';
                    causalIdElement.value = id;

                    const causalText = `${last_name}: ${name}`;
                    const current = textareaElement.value;
                    if (lastAutoText && current.includes(lastAutoText)) {
                        textareaElement.value = current.replace(lastAutoText, causalText);
                    } else if (current.trim()) {
                        textareaElement.value = `${current.trim()}\n${causalText}`;
                    } else {
                        textareaElement.value = causalText;
                    }
                    lastAutoText = causalText;
                });
            },
            preConfirm: async () => {
                const causalId = document.getElementById("causal_id").value;
                const observation = document.getElementById("swal-observations").value.trim();

                if (!observation) {
                    Swal.showValidationMessage(`Escribe una observación ${reasonOf}`);
                    return false;
                }
                if (!causalId) {
                    Swal.showValidationMessage(`Selecciona un causal de ${reasonNoun}`);
                    return false;
                }

                const myHeaders = new Headers();
                myHeaders.append("Authorization", `Bearer ${token}`);
                myHeaders.append("Content-Type", "application/json");

                const raw = JSON.stringify({
                    deletion_reason: observation,
                    causal_anulacion: causalId,
                });

                const requestOptions = {
                    method: "PUT",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                };

                try {
                    const response = await fetch(
                        `${domain}/portal/${tableMeta.id}/${isCustomer ? "delete_request_customer" : "delete_request"}/`,
                        requestOptions
                    );
                    const result = await response.json();
                    if (!response.ok) {
                        throw new Error(result?.msg || `No se pudo procesar ${reasonThe}`);
                    }
                    return result;
                } catch (error) {
                    Swal.showValidationMessage(error.message || `No se pudo procesar ${reasonThe}`);
                    return false;
                }
            },
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "Cambio de estado correcto",
                    text: result.value?.msg,
                    icon: "success",
                }).then(() => window.location.reload());
            }
        });
    };

    if (tableMeta.can_delete) {
        return (
            <>
                <button
                 className='p-1 cursor-pointer bg-red-500 hover:bg-red-600 text-white rounded-md transition-colors'
                    onClick={rechazar}
                    title={actionLabel}
                >
                    <Trash />
                </button>
            </>
        );
    } else return null;
}
